import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ActiveTabEnum, AvailableLanguagesEnum } from "../../../enums";

import Languages from "./Languages";

import user from "../../../assets/img/common/user.svg";
import arrowDown from "../../../assets/img/common/arrowDown.svg";
import rules from "../../../assets/img/common/rules_1.svg";

import UK from "../../../assets/img/common/uk.svg";
import SRSR from "../../../assets/img/common/serbian.svg";
import CRO from "../../../assets/img/common/croatian.svg";
import MNE from "../../../assets/img/common/macedonian.svg";
import SRBA from "../../../assets/img/common/republic_of_srpska.svg";

import coin from "../../../assets/img/common/coins_1.svg";

import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { switchTab } from "../../../store/picks/tabs-slice";
import store from "../../../store/store";
import GameRules from "../ModalMessage/GameRules";

interface Props {
  isSideMenuOpen: boolean;
  isLanguageMenuOpen: boolean;
  setIsLanguageMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeModal: () => void;
}

const SideMenu: React.FC<Props> = ({
  isSideMenuOpen,
  isLanguageMenuOpen,
  setIsLanguageMenuOpen,
  closeModal,
}) => {
  const { t } = useTranslation();
  const userInfo = useAppSelector((state) => state.config.userInfo);
  const language = useAppSelector((state) => state.config.languageIcon);
  const dispatch = useAppDispatch();
  const [showRules, setShowRules] = useState(false);

  const handleBackgroundClick = (): void => {
    document.body.classList.remove("modal_open");
    closeModal();
  };

  const handleRulesModal = (): void => {
    setShowRules((prevShowRules) => !prevShowRules);
    closeModal();
  };

  return (
    <div
      className={`${"side_menu"} ${isSideMenuOpen && "open"}`}
      onClick={handleBackgroundClick}
      role="presentation"
      onKeyDown={(e) => {
        if (e.key === "Enter") handleBackgroundClick();
      }}
    >
      <div
        className="side_menu_cont"
        onClick={(e) => {
          e.stopPropagation();
          setIsLanguageMenuOpen(false);
        }}
        role="presentation"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.stopPropagation();
            setIsLanguageMenuOpen(false);
          }
        }}
      >
        <div className="first_section">
          <div className="user">
            <img src={user} alt="user" />
            <div>
              <span className="name">{userInfo.username}</span>
              <span className="email">{userInfo.email}</span>
            </div>
          </div>
          <div
            className="language"
            onClick={(e) => {
              e.stopPropagation();
              setIsLanguageMenuOpen((prevState) => !prevState);
            }}
            role="button"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.stopPropagation();
                setIsLanguageMenuOpen((prevState) => !prevState);
              }
            }}
            tabIndex={0}
          >
            {language === AvailableLanguagesEnum.ENG && (
              <img src={UK} alt="UK" />
            )}
            {language === AvailableLanguagesEnum.SRSR && (
              <img src={SRSR} alt="srsr" />
            )}
            {language === AvailableLanguagesEnum.SRBA && (
              <img src={SRBA} alt="srba" />
            )}
            {language === AvailableLanguagesEnum.MNE && (
              <img src={MNE} alt="mne" />
            )}
            {language === AvailableLanguagesEnum.CRO && (
              <img src={CRO} alt="cro" />
            )}
            <div className="selected">{language}</div>
            <img className="carrot_down" src={arrowDown} alt="arrow" />
            {isLanguageMenuOpen && <Languages language={language} />}
          </div>
        </div>

        <div className="second_section">
          <button
            type="button"
            className="tab"
            onClick={() => {
              dispatch(switchTab());
              handleBackgroundClick();
            }}
          >
            <img src={coin} alt="coin" />
            <span>
              {store.getState().tab.activeTab === ActiveTabEnum.DRAW
                ? t("footer.draw")
                : t("footer.play")}
            </span>
          </button>

          <button type="button" className="tab" onClick={handleRulesModal}>
            <img src={rules} alt="rules" className="rules_icon" />
            {t("rules.gameRules")}
          </button>

          {showRules && <GameRules closeModal={handleRulesModal} />}
        </div>
      </div>
    </div>
  );
};
export default SideMenu;
